// Tabs con estilo subrayado (como los de cashapp) + badge/budget opcional por tab.
export interface TabItem {
  id: string;
  label: string;
  badge?: number | string;
}

const Tabs = ({
  items,
  activeId,
  onChange
}: {
  items: TabItem[];
  activeId: string;
  onChange: (id: string) => void;
}) => (
  <ul className="intiza-tabs">
    {items.map((tab) => (
      <li key={tab.id}>
        <button
          type="button"
          className={"intiza-tab" + (activeId === tab.id ? " active" : "")}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
          {tab.badge !== undefined && (
            <span className="intiza-tab__badge">{tab.badge}</span>
          )}
        </button>
      </li>
    ))}
  </ul>
);

export default Tabs;
